/* Model */
class StopTypeModel extends App.Models.BaseModel {
    modelUrl = 'StopType';
}

App.Models.StopType = StopTypeModel;

/* Collection */
class StopTypeCollection extends App.Collections.BaseCollection {
    url = 'StopType';
    model = App.Models.StopType;
}

App.Collections.StopTypes = StopTypeCollection;

/* Router */
class StopTypeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'StopType';
        const model = App.Models.StopType;
        const collectionClass = App.Collections.StopTypes;

        super(entityName, model, collectionClass);
    }
}

App.Routers.StopType = StopTypeRouter;
